import NavigateBackWizardStep from "../../components/navigateBackWizardStep";
import { useWizard } from "react-use-wizard";
import AnimatedTextInput from "../../components/animatedTextInput";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";

function ConditionDurationStep({
  initState = null,
  onSubmitHandler,
  qKey,
  patientsConditions,
}) {
  console.log(patientsConditions, "ini");
  const { previousStep, nextStep } = useWizard();
  const [conditionDurations, setConditionDurations] = useState(
    initState || {
      ht: "",
      hpt: "",
      ckd: "",
      dm: "",
      dyslipidemia: "",
      ihd: "",
    }
  );
  const { t } = useTranslation();

  const handleChange = (e) => {
    const { id, value } = e.target;
    setConditionDurations((prevState) => ({
      ...prevState,
      [id]: value,
    }));
  };

  const next = () => {
    const response = {
      _state: conditionDurations,
      formatted_response: [
        {
          type: "TEXT",
          question: "HT (Blood Pressure)",
          code: "Q3C1Q",
          response: conditionDurations["ht"],
        },
        {
          type: "TEXT",
          question: "Hypo-Thyroid",
          code: "Q3C2Q",
          response: conditionDurations["hpt"],
        },
        {
          type: "TEXT",
          question: "CKD (Kidney Disease)",
          code: "Q3C3Q",
          response: conditionDurations["ckd"],
        },
        {
          type: "TEXT",
          question: "DM (Diabetes)",
          code: "Q3C4Q",
          response: conditionDurations["dm"],
        },
        {
          type: "TEXT",
          question: "Dyslipidemia (Cholesterol)",
          code: "Q3C5Q",
          response: conditionDurations["dyslipidemia"],
        },
        {
          type: "TEXT",
          question: "IHD (Ischemic Heart Disease)",
          code: "Q3C6Q",
          response: conditionDurations["ihd"],
        },
      ],
    };
    onSubmitHandler({ [qKey]: response });
    nextStep();
  };

  const inputMissing = () =>
    !(
      conditionDurations.ht &&
      conditionDurations.ckd &&
      conditionDurations.dm &&
      conditionDurations.dyslipidemia
    );

  return (
    <div>
      <NavigateBackWizardStep
        clickHandler={previousStep}
        title={t("hi.title")}
        hideLibrary={true}
      />
      <div className="body_content ">
        <div className="inner_body ">
          <div className="fill_form light_fill_form">
            <h3 className="headtitle">
              Since when do you have the following conditions?
            </h3>
            <div className="mb-4">
              {patientsConditions?.Q3C1?.checked && (
                <div className=" mb-3">
                  <label
                    htmlFor="ht"
                    className="me-3"
                    style={{ minWidth: "180px" }}
                  >
                    HT (Blood Pressure)
                  </label>
                  <AnimatedTextInput
                    placeholder='e.g. "Since 2020" or "2 years"'
                    value={conditionDurations.ht}
                    onChange={handleChange}
                    id="ht"
                  />
                </div>
              )}

              {patientsConditions?.Q3C2?.checked && (
                <div className=" mb-3">
                  <label
                    htmlFor="ht"
                    className="me-3"
                    style={{ minWidth: "180px" }}
                  >
                    Hypo-Thyroid
                  </label>
                  <AnimatedTextInput
                    placeholder='e.g. "Since 2020" or "2 years"'
                    value={conditionDurations.hpt}
                    onChange={handleChange}
                    id="hpt"
                  />
                </div>
              )}

              {patientsConditions?.Q3C3?.checked && (
                <div className=" mb-3">
                  <label
                    htmlFor="ckd"
                    className="me-3"
                    style={{ minWidth: "180px" }}
                  >
                    CDK (Kidney Disease)
                  </label>
                  <AnimatedTextInput
                    placeholder='e.g. "Since 2020" or "2 years"'
                    value={conditionDurations.ckd}
                    onChange={handleChange}
                    id="ckd"
                  />
                </div>
              )}
              {patientsConditions?.Q3C4?.checked && (
                <div className="mb-3">
                  <label
                    htmlFor="dm"
                    className="me-3"
                    style={{ minWidth: "180px" }}
                  >
                    DM (Diabetes)
                  </label>
                  <AnimatedTextInput
                    placeholder='e.g. "Since 2020" or "2 years"'
                    value={conditionDurations.dm}
                    onChange={handleChange}
                    id="dm"
                  />
                </div>
              )}

              {patientsConditions?.Q3C5?.checked && (
                <div className="mb-3">
                  <label
                    htmlFor="dyslipidemia"
                    className="me-3"
                    style={{ minWidth: "180px" }}
                  >
                    Dyslipidemia (Cholesterol)
                  </label>
                  <AnimatedTextInput
                    placeholder='e.g. "Since 2020" or "2 years"'
                    value={conditionDurations.dyslipidemia}
                    onChange={handleChange}
                    id="dyslipidemia"
                  />
                </div>
              )}

              {patientsConditions?.Q3C6?.checked && (
                <div className="mb-3">
                  <label
                    htmlFor="dyslipidemia"
                    className="me-3"
                    style={{ minWidth: "180px" }}
                  >
                    IHD (Ischemic Heart Disease)
                  </label>
                  <AnimatedTextInput
                    placeholder='e.g. "Since 2020" or "2 years"'
                    value={conditionDurations.ihd}
                    onChange={handleChange}
                    id="ihd"
                  />
                </div>
              )}
            </div>

            <div className="btn_block d-flex justify-content-center bottom_button">
              <button
                className="btn btn_primary"
                // disabled={inputMissing()}
                onClick={() => next()}
              >
                {t("login.DOBSTEP.button")}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ConditionDurationStep;
